import { Button, Divider, Flex, Form, InputNumber } from 'antd'
import { SetURLSearchParams } from 'react-router-dom'

export type FormValue = {
  from: number
  to: number
}

type Props = {
  from: string
  to: string
  initialValues?: Partial<FormValue>
  setSearchParams: SetURLSearchParams
  close: () => void
}

export const FilterDropdownNumberRange = ({
  from: fromParam,
  to: toParam,
  initialValues,
  setSearchParams,
  close,
}: Props) => {
  const [form] = Form.useForm<FormValue>()
  const { Item } = Form

  const handleSubmit = async () => {
    try {
      const { from, to } = await form.validateFields()

      if (to < from) return

      setSearchParams((prev) => {
        const params = new URLSearchParams(prev)

        params.delete('page')
        params.set(fromParam, String(from))
        params.set(toParam, String(to))

        return params
      })

      close()
    } catch (e) {
      console.error(e)
    }
  }

  const handleReset = () => {
    form.resetFields()

    setSearchParams((prev) => {
      const params = new URLSearchParams(prev)

      params.delete('page')
      params.delete(fromParam)
      params.delete(toParam)

      return params
    })

    close()
  }

  console.log('initialValues', initialValues)

  return (
    <Form
      form={form}
      layout="inline"
      initialValues={initialValues}
      style={{ padding: 8 }}
    >
      <Flex vertical>
        <Flex gap={8} justify="space-between" align="flex-start">
          <Item
            name="from"
            required={false}
            dependencies={['to']}
            rules={[
              {
                required: true,
                message: 'Required field',
              },
            ]}
            style={{ marginRight: 0, height: 50 }}
          >
            <InputNumber
              style={{ width: 120 }}
              placeholder="From"
              min={0}
              precision={2}
            />
          </Item>

          <span style={{ marginTop: 5 }}>—</span>

          <Item
            name="to"
            required={false}
            dependencies={['from']}
            rules={[
              {
                required: true,
                message: 'Required field',
              },
            ]}
            style={{ marginRight: 0, height: 50 }}
          >
            <InputNumber
              style={{ width: 120 }}
              placeholder="To"
              precision={2}
            />
          </Item>
        </Flex>

        <Item noStyle dependencies={['from', 'to']}>
          {({ getFieldValue }) => {
            const from = getFieldValue('from')
            const to = getFieldValue('to')

            if (from != null && to != null && to < from) {
              return (
                <div
                  style={{
                    marginTop: -18,
                    marginBottom: -5,
                    paddingLeft: 35,
                    color: 'var(--color-red-60)',
                  }}
                >
                  <strong>From</strong> must be <strong>{'<'}</strong> than{' '}
                  <strong>To</strong>
                </div>
              )
            }

            return null
          }}
        </Item>

        <Divider style={{ marginTop: 8, marginBottom: 8 }} />

        <Flex justify="space-between">
          <Button size="small" onClick={handleReset}>
            Reset
          </Button>
          <Button type="primary" size="small" onClick={handleSubmit}>
            OK
          </Button>
        </Flex>
      </Flex>
    </Form>
  )
}
